// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"8882928c","1954":"8629fd6c","3844":"e8054fc0","4134":"b102433b","5119":"4a3da536"}[chunkId] + ".chunk.css";
};